import { render, staticRenderFns } from "./BrandTutorialVideoItem.vue?vue&type=template&id=2416c92b&scoped=true&"
import script from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideoItem.vue?vue&type=style&index=0&id=2416c92b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2416c92b",
  null
  
)

export default component.exports